import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Stores the id of the reusable DynamicComponent that a DynamicComponentElement
// instance should render. Raw and compiled values are the same integer — no
// transform — so the render-side simply reads the option and passes the id to
// `DynamicComponent.get(id)`.
export default class ReferencedComponentId extends BaseOption {
  // Compile is the identity: a cached value unlike the raw one is stale (DynamicOption ignores it).
  static compiledIsRaw = true;

  // NONE suppresses the standalone inspector row (getOptionTools filters it); the picker
  // renders inside ComponentContextBindings instead. Value is still stored/compiled here.
  static userInterfaceComponent = {
    label: "Component",
    component: inspectorTools.NONE,
    props: {},
  };

  static defaultValue = 0;
}
